import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'prgov-stepper-register',
  templateUrl: './stepper-register.component.html',
  styleUrls: ['./stepper-register.component.scss']
})
export class StepperRegisterComponent {

  @Input() public stepperPosition = 0;
  @Input() public stepperArray = [];
  @Input() public typeOfUser = 0;
  @Output() stepperPositionChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(public translate: TranslateService, public authService: AuthService) { }

  onClickStepper(item: number) {
		this.stepperPosition = item;
		this.stepperArray = [];
		if (this.typeOfUser === 1) {
			if (item === 2) {
				this.stepperArray.push(this.stepperPosition);
			} else {
				for (let index = 1; index < item; index++) {
					if (index + 1 !== item) {
						this.stepperArray.push(index + 1);
					}
				}
			}
		} else {
			if (item === 1) {
				this.stepperArray.push(this.stepperPosition);
			} else {
				for (let index = 1; index < item; index++) {
					if (index !== item) {
						this.stepperArray.push(index);
					}
				}
			}
		}

    // tslint:disable-next-line: align
    this.stepperPositionChange.emit({
      stepperPosition: this.stepperPosition,
      stepperArray: this.stepperArray
    });
  }
}
